/* VX Resources V9 — storefront individual-bag guard. No checkout/server-side validation. */
(() => {
  'use strict';
  const bagIds = new Set((window.VXIndividualBagVariantIds || []).map(String));
  const MAX_BAGS = 2;
  const approvedForms = new WeakSet();
  let cartPromise = null;
  const cartPath = (window.Shopify?.routes?.root || '/') + 'cart.js';
  const message = 'Maximum two individual 4 cu. ft. bags per order, across all grades. Please reduce the quantity in your cart.';
  function cartNow() {
    if (!cartPromise) cartPromise = fetch(cartPath, {credentials: 'same-origin', cache: 'no-store'})
      .then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .finally(() => { cartPromise = null; });
    return cartPromise;
  }
  function bagCount(cart) { return cart.items.reduce((n, item) => n + (bagIds.has(String(item.variant_id)) ? item.quantity : 0), 0); }
  function currentId(form) { return String(form.querySelector('input[name="id"]')?.value || ''); }
  function currentQuantity(form) { return Number(form.querySelector('[name="quantity"]')?.value || 1); }
  function showError(form, msg) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const target = wrapper?.querySelector('.product-form__error-message');
    if (target && wrapper) { target.textContent = msg; wrapper.hidden = false; }
    else window.alert(msg);
  }
  function updateProductUI(cart) {
    const total = bagCount(cart);
    document.querySelectorAll('product-form form').forEach(form => {
      const id = currentId(form), isBag = bagIds.has(id);
      const button = form.querySelector('button[type="submit"]');
      const product = form.closest('section, .shopify-section') || document;
      const quantity = product.querySelector('input.quantity__input[name="quantity"]');
      if (!isBag) return;
      const own = cart.items.filter(item => String(item.variant_id) === id).reduce((n,item) => n + item.quantity,0);
      const remaining = Math.max(0, MAX_BAGS - total);
      if (quantity) {
        // Dawn's quantity-input subtracts data-cart-quantity from data-max.
        // The cap is therefore (remaining + this variant's existing cart count).
        const dawnMax = remaining + own;
        quantity.dataset.max = String(dawnMax);
        quantity.max = String(dawnMax);
        quantity.min = '1';
        quantity.dataset.min = '1';
        quantity.disabled = remaining === 0;
        if (!Number.isFinite(Number(quantity.value)) || Number(quantity.value) < 1 || Number(quantity.value) > remaining)
          quantity.value = '1';
        const plus = quantity.closest('quantity-input')?.querySelector('button[name="plus"]');
        if (plus) plus.disabled = remaining === 0 || Number(quantity.value) >= remaining;
      }
      if (button) button.disabled = remaining === 0;
    });
  }
  async function refresh() { try { updateProductUI(await cartNow()); } catch(e) { console.warn('VX cart check:',e); } }
  // Capture before Dawn's product-form handler or ordinary /cart/add forms.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('product-form form, form[action*="/cart/add"]')) return;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    if (!bagIds.has(currentId(form))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const cart = await cartNow();
      const qty = currentQuantity(form);
      if (!Number.isInteger(qty) || qty < 1 || bagCount(cart) + qty > MAX_BAGS) {
        showError(form, message); updateProductUI(cart); return;
      }
      approvedForms.add(form);
      form.requestSubmit(button || undefined);
      // On full-page navigations this is immaterial; for Ajax updates refresh on return.
      setTimeout(refresh, 900);
    } catch(e) { showError(form, 'Could not verify your cart. Please try again.'); }
    finally { if (button) button.disabled = false; }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="id"], input.quantity__input')) setTimeout(refresh, 50);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(refresh, 250);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
